import React, { useEffect, useRef } from 'react'
import * as E from '../../elementor'
import TestimonialCard from './TestimonialCard'
import SwiperNext from '../../images/swiper-right.svg'
import SwiperPrev from '../../images/swiper-left.svg'
import { register } from 'swiper/element/bundle'

import 'swiper/scss'
import 'swiper/scss/scrollbar'
import 'swiper/scss/navigation'
register()

const SocialProofCarousel = ({ section }) => {
  const { button, slides, heading, textEditor } = E.collect(section)
  const slideGroup = slides[0]?.slides
  const groupHasImages = slides[0]?.slides.filter(slide => slide.background_image?.url).length > 0

  const swiperRef = useRef(null)
  const nextRef = useRef(null)
  const prevRef = useRef(null)

  useEffect(() => {
    const swiperContainer = swiperRef.current
    const params = {
      spaceBetween: 24,
      scrollbar: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextRef.current,
        prevEl: prevRef.current
      },
      breakpoints: {
        0: {
          slidesPerView: 1.15,
          spaceBetween: 16,
          centeredSlides: true,
        },
        400: {
          slidesPerView: 1.15,
          spaceBetween: 16,
          centeredSlides: true,
        },
        500: {
          slidesPerView: 1.5,
          spaceBetween: 16,
          centeredSlides: false,
        },
        600: {
          slidesPerView: 1.8,
          spaceBetween: 16,
          centeredSlides: false,
        },
        700: {
          slidesPerView: 2.2,
          spaceBetween: 16,
        },
        1000: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        1300: {
          slidesPerView: 3.2,
          spaceBetween: 24,
        }
      },
      injectStyles: [
        `
        .swiper-wrapper {
          margin-bottom: 2rem;
        }
        .swiper-scrollbar {
          background: #f5f5f5;
        }
        .swiper-scrollbar.swiper-scrollbar-horizontal {
          height: 2px;
          left: 0;
        }
        .swiper-scrollbar-drag {
          background: #262626;
        }
      `
      ]
    }

    if (swiperContainer !== undefined && swiperContainer !== null) {
      Object.assign(swiperContainer, params);
      (swiperContainer as any).initialize()
    }
  }, [])

  return (
    <section>
      <div className='social-proof-carousel-wrapper'>
        <div className='title-wrapper'>
          <h2 className='heading'>{heading[0]?.title}</h2>
          <h3 className='subhead'>{textEditor[0]?.text()}</h3>
        </div>
        <div className='cards-wrapper'>
        <button ref={prevRef} className='swipe-prev' aria-label='Previous slide' style={{ backgroundImage: `url(${SwiperPrev})`}} />
          <swiper-container slidesPerView='3' ref={swiperRef} init='false'>
            {slideGroup.map((slide, index) => {
              return <TestimonialCard slide={slide} groupHasImages={groupHasImages} key={index} />
            })}
          </swiper-container>
          <button ref={nextRef} className='swipe-next' aria-label='Next slide' style={{ backgroundImage: `url(${SwiperNext})`}} />
        </div>
      </div>
    </section>
  )
}

export default SocialProofCarousel
